import '../../../models/account_settings/conversation_attributes/hierarchical_tags.js.coffee'
Namespace 'CustomerVisualMode'

class CustomerVisualMode.HierarchicalAttributeWidgetDataTranslator
  constructor: (hierarchicalTag) ->
    tags = hierarchicalTag.get('hierarchical_tags').tags
    @hierarchicalTags = new AccountSettings.ConversationAttributes.HierarchicalTagCollection(tags)

  name: (tagCode) ->
    @hierarchicalTags.getTag(tagCode.name).get('description')
